import loginApi from "../../../api/login/login";

const state = {
  mode: "",
  url: [],
  allowBack: false,
  time: 0,
  number: 0,
  status: "delete",
  noScroll: false
};

const getters = {};

const mutations = {
  // 改变状态
  change(state, { data }) {
    state.mode = data;
  },
  changeStatus(state, { data }) {
    state.status = data;
  },
  // 存第三方链接
  setUrl(state, { data }) {
    state.url = data;
  },
  cleartime(state) {
    state.time = 0;
  },
  addtime(state) {
    state.time = state.time + 1;
  },
  // 存一下通知数量
  setNumber(state, { number }) {
    state.number = number;
  },
  scroll(state, { data }) {
    state.noScroll = data;
    console.log(data);
  }
};

const actions = {
  // 登录
  signIn({ state }, { params, callback }) {
    console.log(state);
    loginApi.signInApi({ params, callback }, res => {
      callback(res);
    });
  },
  signOut({ state }, { callback }) {
    console.log(state);
    loginApi.signOutApi({ callback }, res => {
      callback(res);
    });
  },
  // 首次创建密码
  createPassword({ state }, { params, callback }) {
    console.log(state);
    loginApi.createApi({ params, callback }, res => {
      callback(res);
    });
  },
  // 获取第三方的东西
  getUrl({ state }, { callback }) {
    console.log(state);
    loginApi.getUrlApi({ callback }, res => {
      callback(res);
    });
  },
  // 忘记密码
  forgot({ state }, { params, callback }) {
    console.log(state);
    loginApi.forgotApi({ params, callback }, res => {
      callback(res);
    });
  },
  // 从邮件跳过来修改密码
  // 忘记密码
  update({ state }, { params, callback }) {
    console.log(state);
    loginApi.updateApi({ params, callback }, res => {
      callback(res);
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/login/login.js